import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfoCardComponent } from '../../shared/components/info-card/info-card.component';
import { ActionCardComponent, ActionCardData } from '../../shared/components/action-card/action-card.component';


/**
 * WHY: Final wedding info page with direct HTML card definitions for easier customization
 * SOLID: Single responsibility - comprehensive wedding information display
 */
@Component({
  selector: 'app-wedding-info-final',
  templateUrl: './wedding-info-final.html',
  imports: [CommonModule, RouterModule, InfoCardComponent, ActionCardComponent]
})
export class WeddingInfoFinalComponent {

  // WHY: Action cards data
  protected readonly actionCards = signal<ActionCardData[]>([

    {
      title: 'Jetzt anmelden!',
      description: 'Wir freuen uns riesig auf euch! Bitte meldet euch bis zum 01. Mai 2026 zurück.',
      buttonText: 'Zur Anmeldung',
      routerLink: '/form'
    },
    {
      title: 'Noch Fragen?',
      description: 'Bei weiteren Fragen könnt ihr euch jederzeit gerne an uns wenden!',
      buttonText: 'Kontaktformular',
      routerLink: '/contact'
    },
  ]);

}